import ax, { S3_API, validateResponse } from '%/axios';
import axios from 'axios'
import conso from './conso';


// file is of file object type, path is string, 
// type is string, cb is callback function
export const sendServerFile = async (file, path, cb = null, limit = 8) => {
  conso.log('file size is: ', file.size);
  if (file.size > limit * (1000000))
    return alert(`File size too large - ${limit}MB limit`);
  const formData = new FormData();
  formData.append('file', file);
  formData.append('path', path);
  formData.append('cmd', 'store');
  try {
    const res = await axios
      .post(S3_API, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          'X-CSRF-TOKEN': document.getElementById('csrf-token').getAttribute('content')
        }
      });
    if (!validateResponse(res.data)) {
      if (process.env.MIX_APP_ENV === 'local')
        conso.trace(res.data)
      throw new Error();
    } else if (!!res.data.data && !Array.isArray(res.data.data))
      return [];
    if (cb) {
      cb(res.data.data);
    }
    if (!res.data.data) {
      // failure case
      throw new Error('File not found');
      // return new Error('File not found');
    }
    // for get: response is binary data, for post: file path as string
    return res.data.data; // property which holds temp url
  } catch (er) {
    conso.trace(er);
    throw new Error();
  }
}

// corresponds with possible types 
export const s3FolderLegend = {
  'photo_url': 'Profile pictures',
  'company_logo': 'Company logo',
  'video_pitch': 'Candidate video pitches',
  'video_response': 'Video answer to an assessment question from job application',
  'resumes': 'resumes',
  'covers': 'cover letters',
  'video_blog': 'video blog file',
  'photo_blog': 'blog photo header',
  'company_video': 'Company video',
  'product_img': 'Product Media Image'
}

export const dirNames = {
  'photo_url': 'images',
  'banner_photo': 'images',
  'company_logo': 'images',
  'video_pitch': 'videos',
  'video_response': 'assessments',
  'resumes': 'resumes',
  'covers': 'covlets',
  'video_blog': 'blogs',
  'photo_blog': 'blogs',
  'company_videos': 'videos',
  'img_url': 'blogs',
  'blog_url': 'blogs',
  'video': 'videos',
  'document': 'documents',
  'product_img': 'Product Media Image'

}


const fileNameLabels = {
  'photo_url': {
    label1: 'userid',
    label2: '',
    label3: ''
  },
  'banner_photo': {
    label1: 'userid',
    label2: '',
    label3: ''
  },
  'company_logo': {
    label1: 'companyid',
    label2: '',
    label3: ''
  },
  'video_pitch': {
    label1: 'userid',
    label2: '',
    label3: ''
  },
  'video_response': {
    label1: 'assesid',
    label2: 'questionid',
    label3: 'candidateid'
  },
  'resumes': {
    label1: 'userid',
    label2: '',
    label3: ''
  },
  'covers': {
    label1: 'userid',
    label2: '',
    label3: ''
  },
  'video_blog': {
    label1: 'userid',
    label2: '',
    label3: ''
  },
  'photo_blog': {
    label1: 'userid',
    label2: '',
    label3: ''
  },
  'company_videos': {
    label1: 'companyid',
    label2: '',
    label3: ''
  },
  'img_url': {
    label1: 'userid',
    label2: '',
    label3: ''
  },
  'blog_url': {
    label1: 'userid',
    label2: '',
    label3: ''
  },
  'video': {
    label1: 'companyid',
    label2: '',
    label3: '',
  },
  'document': {
    label1: 'appid',
  },

}

// string splitting which takes a relative path 
// e.g. '/path/to/fileName.mp4' 
// and returns 'fileName.mp4'
export const getFileNameFromValue = (fullPath) => {
  if (fullPath) {
    const startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
    let filename = fullPath.substring(startIndex);
    if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
      filename = filename.substring(1);
    }
    return filename;
  }
  return 'smhm';
}

export const getFileExtension = (str = '') => {
  const val = str.split('.').pop();
  return val;
}

export function randStr(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}
export const generateFileName = (type, user_id, fullPath, id2 = null, id3 = null) => {
  return `${type}_${randStr(5)}_${new Date().getTime()}.${getFileExtension(getFileNameFromValue(fullPath))}`
}


// id can be user_id, company_id  
export const generateFilePath = (type, id, fullPath, id2 = null, id3 = null, id4 = null) => {
  if (!generateFileName(type, id, fullPath))
    return null;

  switch (type) {
    // id is user_id
    case 'product_images':
      return `/product_images/${id}/${generateFileName(type, id, fullPath)}`;
    case 'banner_photo':
      return `/user_id${id}/${dirNames[type]}/${generateFileName(type, id, fullPath)}`;

    case 'video_pitch':
      return `/user_id${id}/${dirNames[type]}/${generateFileName(type, id, fullPath)}`;
    // id is company_id
    case 'company_logo':
      return `/company_id${id}/${dirNames[type]}/${generateFileName(type, id, fullPath)}`;
    case 'video':
      return `/company_id${id}/${dirNames[type]}/${generateFileName(type, id, fullPath)}`;

    // id is assessment_id, id2 is user_id(candidate), id3 is question_id, id4 is employer (assessment owner)
    case 'company_videos':
      return `/company_id${id}/${dirNames[type]}/${generateFileName(type, id, fullPath)}`;

    case 'video_response':
      return `/user_id${id4}/assessment_id${id}/user_id${id2}/${generateFileName(type, id, fullPath, id3, id2)}`;

    case 'resumes':
      return `/user_id${id}/${dirNames[type]}/${generateFileName(type, id, fullPath)}`;
    case 'covers':
      return `/user_id${id}/${dirNames[type]}/${generateFileName(type, id, fullPath)}`;

    // for blogs, id is blog_id, id2 is user_id
    case 'blog_url':
      return `/user_id${id2}/${dirNames[type]}/blog_id${id}/videos/${generateFileName(type, id, fullPath)}`;
    case 'img_url':
      return `/user_id${id2}/${dirNames[type]}/blog_id${id}/images/${generateFileName(type, id, fullPath)}`;
    case 'document':
      return `/user_id${id}/${dirNames[type]}/candidate_id${id2}/${generateFileName(type, id3, fullPath)}`
    case 'open-graph':
      return `/open_graph/${generateFileName(type, 0, fullPath)}`
    default:
      return null;
  }
}

export const getServerFile = async (path) => {
  const formData = new FormData();
  try {
    formData.append('path', path);
    formData.append('cmd', 'get');
    const res = await axios.post('/asset', formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        'X-CSRF-TOKEN': document.getElementById('csrf-token').getAttribute('content')
      }
    });
    if (!validateResponse(res.data)) {
      if (process.env.MIX_APP_ENV === 'local')
        conso.trace(res.data)
      // throw new Error();
    }
    // example res.data.data == {status: '', temp: '' }
    if (res.data.data?.indexOf('/') > -1)
      return res.data.data; // property which holds temp url
  } catch (er) {
    conso.trace(er);
    throw new Error();
    return false;
  }

}

export const generateLimitEr = limit =>
  `Could not submit. File exceeds ${limit} MB limit`;

// format: [s3type]: [numMaximumSize] 
export const fileLimits = {
  'photo_url': 25,
  'banner_photo': 25,
  'company_logo': 25,
  'video_pitch': 100,
  'video_response': 100,
  'resumes': 25,
  'covers': 25,
  'video_blog': 100,
  'photo_blog': 25,
  'company_videos': 100,
  'img_url': 25,
  'blog_url': 100,
  'video': 100,
  'document': 25
}
